import {
	Error,
	PostFormFormParticipationByFormIdData,
	PostFormFormParticipationByFormIdParams
} from '../../../models/__generated/data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class FormApi<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags Form:FormParticipation
	 * @name PostFormFormParticipationByFormId
	 * @summary Create one FormParticipation
	 * @request POST:/api/acl-service/v1/front/form-service/form-participation/{formId}
	 * @response `200` `PostFormFormParticipationByFormIdData` Success
	 * @response `400` `Error`
	 */
	postFormFormParticipationByFormId = (
		{ formId, ...query }: PostFormFormParticipationByFormIdParams,
		params: RequestParams = {}
	) =>
		this.http.request<PostFormFormParticipationByFormIdData, Error>({
			path: `/api/acl-service/v1/front/form-service/form-participation/${formId}`,
			method: 'POST',
			query: query,
			...params
		});
}
